import IcArrow from './IcArrow'

export default IcArrow
